angular.module('omfm').service('WkSystem', WkSystemService);

WkSystemService.$inject = ['$resource', 'ServerInterceptor'];

function WkSystemService($resource, ServerInterceptor) {
	return $resource('/reports/wk_system', {"id": "@id"}, {
		'filters': {
			'url': "/reports/wk_system/filters",
			'method': 'get',
			'interceptor': ServerInterceptor
		},
		'list': {
			'url': "/reports/wk_system/list",
			'method': 'post',
			'interceptor': ServerInterceptor
		},
		'group': {
			'url': "/reports/wk_system/group",
			'method': 'post',
			'interceptor': ServerInterceptor,
			isArray: true
		}
	})
}